import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import { Checkmark16Filled } from '@fluentui/react-icons';
import React from 'react';
import { FOLDER_COLORS } from '@axys-notes/common';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: tokens.spacingHorizontalM,
    padding: `${tokens.spacingVerticalS} 0`,
  },
  colorButton: {
    width: '36px',
    height: '36px',
    borderRadius: tokens.borderRadiusCircular,
    border: '3px solid transparent',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    boxShadow: `0 2px 4px ${tokens.colorNeutralShadowAmbient}`,
    '&:hover': {
      transform: 'scale(1.15)',
      boxShadow: `0 4px 8px ${tokens.colorNeutralShadowKey}`,
    },
  },
  colorButtonSelected: {
    border: `3px solid ${tokens.colorNeutralForeground1}`,
    transform: 'scale(1.1)',
    boxShadow: `0 0 0 2px ${tokens.colorNeutralBackground1}, 0 4px 8px ${tokens.colorNeutralShadowKey}`,
  },
  checkIcon: {
    color: 'white',
    filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.3))',
  },
});

interface ColorPickerProps {
  selectedColor: string;
  onChange: (color: string) => void;
}

export const ColorPicker = ({ selectedColor, onChange }: ColorPickerProps) => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      {FOLDER_COLORS.map((color) => (
        <button
          key={color}
          type="button"
          className={mergeClasses(
            styles.colorButton,
            selectedColor === color && styles.colorButtonSelected
          )}
          style={{ backgroundColor: color }}
          onClick={() => onChange(color)}
          aria-label={`Couleur ${color}`}
        >
          {selectedColor === color && (
            <Checkmark16Filled className={styles.checkIcon} />
          )}
        </button>
      ))}
    </div>
  );
};
